import axios from "axios";
import router from "./router";
import Element from "element-ui"

const request = axios.create({
	timeout: 60000,
	headers: {
		'Content-Type': "application/json; charset=utf-8"
	}
})

request.interceptors.request.use(config => {
  const url = config && config.url ? config.url : ''
  const skipAuth = url.includes('/api/login') || url.includes('/api/captcha')
  const token = localStorage.getItem("token")
  if (!skipAuth && token) {
    config.headers['token'] = token
    // 兼容真实后端常见的认证头部
    config.headers['Authorization'] = `Bearer ${token}`
  } else {
    // 对于登录、验证码等公共接口不携带token，避免后端误判401
    if (config.headers && config.headers['token'] !== undefined) {
      delete config.headers['token']
    }
    if (config.headers && config.headers['Authorization'] !== undefined) {
      delete config.headers['Authorization']
    }
  }
	return config
})

request.interceptors.response.use(
	response => {
		if (response.data.code === 200 || response.request.responseURL.match('/assign/phone/assign')) {
			return response
		} else {
			Element.Message.error(!response.data.msg ? '系统异常' : response.data.msg)
      if(response.request.responseURL.match('/login')) {
        return response
      }
			return Promise.reject(response.data.msg)
		}
	},
	error => {
		console.log(error)
		if (error.response && error.response.data) {
			error.massage = error.response.data.msg
		}

		if (error.response && error.response.status === 401) {
      const url = (error.config && error.config.url) ? error.config.url : ''
      const skipAuth = url.includes('/api/login') || url.includes('/api/captcha')
      if (!skipAuth) {
        localStorage.clear()
        router.push("/login")
      }
		}

		Element.Message.error(error.message, {duration: 3000})
		return Promise.reject(error)
	}
)

export default request



// WEBPACK FOOTER //
// ./src/axios.js